import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useAlertNotification } from "../../../../../common/hooks/useAlertNotification";
import RestrictionsList from "./RestrictionsList";
import { usePlansData } from "../../../../../common/hooks/useRatePlansData";

const restrictionsEditorStyle = ({ theme }) => ({
    '& .MuiDialog-paper': {
        width: '80%',
        maxWidth: '1500px'
    }
});

const RestrictionsEditor = ({ propertyId, onClose, ratePlan, onSuccess, onError }) => {
    const { setAlert } = useAlertNotification();

    const { deleteRestriction } = usePlansData(propertyId);

    const title = `Editing restrictions of plan: ${ratePlan.name}`;

    const onUpdateRestriction = () => {
        setAlert({
            message: "Restriction successfully updated!",
            severity: 'success'
        });
    }

    const onCreateRestriction = () => {
        setAlert({
            message: "Restriction successfully created!",
            severity: 'success'
        });
    }

    const onDeleteRestriction = () => {
        setAlert({
            message: "Restriction successfully deleted!",
            severity: 'success'
        });
    }

    return <>
        <Dialog open sx={restrictionsEditorStyle}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <RestrictionsList
                    ratePlan={ratePlan}
                    propertyId={propertyId}
                    onCreateRestriction={onCreateRestriction}
                    onUpdateRestriction={onUpdateRestriction}
                    onDeleteRestriction={onDeleteRestriction}
                    deleteRestriction={(restrictionId => deleteRestriction(ratePlan.id, restrictionId))}
                    onError={onError}
                />
            </DialogContent>
            <DialogActions>
                <Button variant='contained' onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    </>;
}

export default RestrictionsEditor;